import React from 'react';
import './GoalCard.css'

const GoalCard = (props) => {
    return ( 
        <div className='GoalCard'>
            <p className='GCardTitle'>{props.GCardTitle}</p>
            <p className='GCardP'>
                {props.GCardP}
            </p>
        </div>
     );
}
 
export default GoalCard;